module.exports = __webpack_public_path__ + "static/media/ill_huvudvark.df66d3d1.svg";